const TYPES = {
    LOGIN: "LOGIN",
    LOGOUT: "LOGOUT"
};

const defaultValue = {
    authState: false,
    userProfile: undefined
};
const reducer = (state, action) => {
    switch (action.type) {
        case TYPES.LOGIN:
            return {
                authState: true,
                userProfile: action.payload
            };
        case TYPES.LOGOUT:
            return {
                authState: false,
                userProfile: undefined
            };
        default:
            return state;
    }
};

const authenticateReducer = {
    TYPES,
    defaultValue,
    reducer
};

export default authenticateReducer;